module.exports = __webpack_public_path__ + "img/img_right@2x.d7837b26.png";